import PropTypes from 'prop-types'
import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(({ colors, blockColors }) => ({
  spin: {
    animation: '$rotation 1s linear infinite',
    border: ({ strokeWidth, trackColor }) =>
      `solid ${strokeWidth}px ${colors[trackColor] || blockColors[trackColor]}`,
    borderBottomColor: ({ strokeColor }) =>
      colors[strokeColor] || blockColors[strokeColor],
    borderRadius: '50%',
    content: '',
    height: ({ size }) => size,
    width: ({ size }) => size,
    display: 'inline-block'
  },

  '@keyframes rotation': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
}))

function Spinner({ size, strokeColor, strokeWidth, trackColor }) {
  const classes = useStyles({ size, strokeColor, strokeWidth, trackColor })

  return <div className={classes.spin} />
}

Spinner.propTypes = {
  size: PropTypes.number,
  strokeColor: PropTypes.string,
  strokeWidth: PropTypes.number,
  trackColor: PropTypes.string
}

Spinner.defaultProps = {
  size: 22,
  strokeColor: 'linkWater',
  strokeWidth: 2,
  trackColor: 'greyPale'
}

export default Spinner
